<template>
  <div class="sticky-bar" :style="cusStyle">
    <div class="sticky-container">
      <template v-if="!!anchors[0].name">
        <div class="sticky-list">
          <router-link v-for="(item, index) in anchors"
                       :to="{name: item.name, params: item.params}"
                       :key="index">
            <i class="icon-box"
               :style="{'background-image': 'url('+item.icon+')'}"></i>
            {{item.title}}
          </router-link>
        </div>
      </template>
      <template v-else>
        <div class="sticky-list">
          <a href="javascript:void(0)"
             v-for="(item, index) in anchors"
             :class="{'active': item.id === active}"
             :key="index"
             @click="goAnchor(item.id)">
            <i class="icon-box"
               :style="{'background-image': 'url('+item.icon+')'}"></i>
            {{item.title}}
          </a>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'StickyBar',
    props: {
      anchors: {
        required: true,
        type: Array
      },
      cusStyle: {
        required: false,
        type: String
      }
    },
    data () {
      return {
        active: '',
        offsets: []
      }
    },
    methods: {
      goAnchor (selector) {
        let anchor = document.getElementById(selector);

        this.active = selector;
        window.scrollTo(0, anchor.offsetTop - this.$el.offsetHeight - 80);
      },
      initOffsets () {
        this.anchors.forEach(element => {
          this.offsets.push(document.getElementById(element.id).offsetTop - 180);
        });
      },
      scrollActive (top) {
        var i = 0,
          l = this.offsets.length;

        for (; i < l - 1; i++) {
          if ((top + window.screen.height / 2) >= this.offsets[i] && top < this.offsets[i + 1]) {
            this.active = this.anchors[i].id;
            return false;
          } else {
            this.active = this.anchors[i + 1].id;
          }
        }
      }
    },
    mounted () {
      let self = this;

      if (!(this.anchors[0].name)) {
        window.onscroll = function () {
          var top = document.body.scrollTop ||
            document.documentElement.scrollTop ||
            window.pageYOffset;

          self.scrollActive(top);
        }

        this.initOffsets();
      }
    }
  }
</script>

<style lang="scss">
  @import '../assets/style/base.scss';
  @import '../assets/style/public.scss';

  .sticky-bar {
    height: 56px;
    background-color: #f4f4f4;
    margin-bottom: 50px;
    $theme-color: #00ccff;
    position: -webkit-sticky;
    position: sticky;
    padding-top: 2px;
    top: 58px;
    z-index: 9;
    .sticky-container {
      @include public_content();
      height: 100%;
      .sticky-list {
        padding: 0 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        a {
          font-size: 18px;
          color: #959595;
          padding: 12px 22px 12px 32px;
          margin: 0 24px;
          border-top: 2px solid transparent;
          border-bottom: 2px solid transparent;
          .icon-box{
            display: inline-block;
            width: 28px;
            height: 28px;
            margin-right: 6px;
            margin-left: -14px;
            float: left;
            background-repeat: no-repeat;
            background-position: center 0;
          }
          &:hover,
          &.active,
          &.router-link-active {
            color: $theme-color;
            border-top: 2px solid $theme-color;
            border-bottom: 2px solid $theme-color;
            .icon-box{
              background-position: 0 -32px;
            }
          }
        }
      }
    }
  }

  .mobile .sticky-bar{
    @include c-wrap();
    background-color: #fff;
    top: 0;
    margin-top: 0;
    margin-bottom: 0;
    height: .87rem;
    box-shadow: .03rem 0 .07rem rgba(0, 0, 0, .08);
    text-align: center;
    .sticky-container{
      width: 100%;
      overflow: auto;
      .sticky-list{
        display: block;
        padding: 0;
        a{
          display: inline-block;
          border: 0;
          margin: 0;
          padding: 0 .225rem;
          font-size: .32rem;
          line-height: .87rem;
          color: #7a7a7a;
          position: relative;
          z-index: 1;
          i{
            display: none;
          }
          &.router-link-active{
            color: #00ccff;
            &:after{
              content: '';
              display: inline-block;
              width: .53rem;
              height: .07rem;
              background: #00ccff;
              border-radius: 1rem;
              position: absolute;
              bottom: 0;
              left: 50%;
              margin-left: -.265rem;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/stickyBar.vue